import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencyConvert',
  standalone: true,
})
export class CurrencyConvertPipe implements PipeTransform {
  private readonly RATES: { [key: string]: number } = {
    JA: 8.78,
    EN: 1340,
    KO: 1,
  };

  transform(valueString: string | undefined, to: 'JA' | 'EN' | 'KO' | undefined): number {
    if (!valueString) return 0;
    const value = Number(valueString);
    const rate = to ? this.RATES[to] : 1;
    if (!rate) return value;

    const converted = value / rate;

    if (to === 'JA' || to === 'KO') return Math.round(converted);

    return Math.round(converted * 100) / 100;
  }
}
